module.exports = __webpack_public_path__ + "static/media/lightCould.a4af5340.ico";